'use client'

import React, { useMemo } from 'react'
import ProductCard from '@/components/Catalog/ProductCard'
import Slider from '@/components/Catalog/Slider'
import { useIsLoggedIn } from '@/hooks/business/auth/useIsLoggedIn'
import { useCustomerRecommendations, useRelatedProducts } from '@/hooks/business/catalog'
import type { ICartItem } from '~/schemas/cart/cart'

interface ICartRecommendationsProps {
    items: ICartItem[]
}

/**
 * "Escolhidos especialmente para você": com cliente logado, os recomendados para ele; sem login, os relacionados aos
 * produtos do carrinho.
 */
const CartRecommendations: React.FC<ICartRecommendationsProps> = ({ items }) => {
    const isLoggedIn = useIsLoggedIn()
    const productIds = useMemo(() => (isLoggedIn ? [] : items.map((item) => item.product.id)), [isLoggedIn, items])
    const customer = useCustomerRecommendations()
    const related = useRelatedProducts(productIds)
    const products = isLoggedIn ? customer.products : related.products

    return (
        <div className="container mx-auto mt-20 max-md:pb-16 max-lg:-pb-16">
            <span className="flex items-center justify-center w-full px-2 my-8 font-bold font-sora text-destaques-hover align-center md:text-lg md:items-start md:align-start md:justify-start">
                Escolhidos especialmente para você:
            </span>
            <div className="relative overflow-hidden h-fit">
                <Slider desktopItems={3}>
                    {products.map((product) => (
                        <ProductCard key={product.id} data={product} />
                    ))}
                </Slider>
            </div>
        </div>
    )
}

export default CartRecommendations
